//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';

export class MileageDisplayItem extends ItemBase {
    Date: string = "1970-01-01T00:00:00";
    Destination: string | null = null;
    Distance: number = 0;
    DurationInMinutes: number | null = null;
    ID: string | null = null;
    NextID: string | null = null;
    Notes: string | null = null;
    Odometer: string | null = null;
    Rate: number | null = null;
    RepeatDetails: RepeatDetailsItem | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    TeacherID: string | null = null;
    TotalCost: number | null = null;
    Vehicle: string | null = null;
    UseRepeatDetails: boolean = false;

    constructor(initializer?: Partial<MileageDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "MileageDisplayItem";
}
